












































































import { Component, Vue } from "vue-property-decorator";
import { User } from "@/components/User";
import { L } from "@/common/filters";

@Component
export default class ForgotPassword extends Vue {
  UserName:string = null;
  submitted:number = 0;
  emailIsValid:boolean = false;
  email: string = '';
  errorMessage: string = '';

  successfulMessage:string = L('sForgotPasswordSent');

  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  emailChecking:boolean = false;
  emailError:string[] = [];
  async checkAvailability(value:string) {
    this.emailError = [];
    if (value) {
      try {
        this.emailChecking = true;
        let available = await this.User.requestResource('user/availability', 'GET', {
          email: value
        });
        this.emailChecking = false;
        if (available.email) {
          this.emailError = [L('notRegistered')];
        }
      } catch (error) {
        this.emailChecking = false;
        this.emailError = [error.message || 'Validation Error'];
      }
      this.emailIsValid =  this.emailError.length==0;
    }
  }

  get rules () {
    return {
      required: value => !!value || L('required'),
      email: value => {
        let valid:boolean = this.User.validateEmail(value);
        this.emailError = [];
        this.emailIsValid = valid;
        if (valid) {
          this.checkAvailability(value);
        }
        return valid || L('invalidEmail');
      }
    };
  }

  get User() : User {
    return this.$store.getters.User;
  }

  set User(user:User) {
    this.$store.commit('notifyChange', {
      User: user
    });
  };

  async requestPassword() {
    try {
      this.submitted = 1;
      let user = await this.User.requestResource('user/forgotpassword', 'PUT', {
        email: this.email
      });
      let me:User = new User({
        GivenName: user.name,
        Surname: user.surname
      });
      this.UserName = me.FullName;
      this.submitted = 2;
    } catch (error) {
      this.submitted = -1;
      this.errorMessage = error.message || "Request password error";
    }
  }

  cancel() {
    this.$emit('changeMenu',{
      name: 'login'
    });
  }
}
